import React, { useState } from 'react';
import Breadcrumb from '../components/layout/Breadcrumb';
import Seo from '../components/Seo';
import ProductCard from '../components/home/ProductCard';
import ProductDrawer from '../components/layout/ProductDrawer';
import caseStudies from '../data/productsData';

function ProductPage() {
  const [selectedProduct, setSelectedProduct] = useState(null);

  return (
    <div className="min-h-screen bg-[#fafafa] text-slate-900 antialiased font-sansSelection">

      <Seo
        title="Wire Harness Products | PVS Harness Solution"
        description="Explore our range of automotive and industrial wire harness assemblies and manufacturing assets, built for durability and precision."
        path="/products"
        schema={{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://pvsharness.com/" },
            { "@type": "ListItem", "position": 2, "name": "Products", "item": "https://pvsharness.com/products" }
          ]
        }}
      />

      <Breadcrumb
        heading="Products"
        links={[
          { label: "Home", url: "/" },
          { label: "Products" }
        ]}
      />

      <div className="max-w-7xl mx-auto px-6 py-16 lg:py-20">

        {/* Header */}
        <header className="max-w-2xl mb-14">
          <h1 className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl text-slate-950 tracking-tight leading-tight">
         Our Products & Manufacturing Assets
          </h1>
        </header>

        {/* Product Grid */}
        <main>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-10">
            {caseStudies.map((product, index) => (
              <div key={`${product.id}-${index}`} className="flex flex-col">
                <ProductCard
                  img={product.img}
                  alt={product.alt}
                  title={product.title}
                  onViewClick={() => setSelectedProduct(product)}
                />
                
              </div>
            ))}
          </div>
        </main>
      </div>

      <ProductDrawer
        product={selectedProduct}
        onClose={() => setSelectedProduct(null)}
      />
    </div>
  );
}

export default ProductPage;